// ADR-109: display helpers for the stable unique CV code ("Candidate No.").
// The code itself is generated server-side (radar-api cvCode.service); the
// frontend only displays it. Mirrors formatCvCode in the backend.

/**
 * Groups a numeric code in fours for display: "48291367" -> "4829 1367".
 * Non-numeric or empty input is returned unchanged.
 * @param {string} code
 * @returns {string}
 */
export const formatCvCode = (code) => {
  if (typeof code !== 'string' || !/^\d+$/.test(code)) return code;
  return code.replace(/(\d{4})(?=\d)/g, '$1 ');
};

/**
 * Label printed on a CV whose name is obfuscated.
 * @param {string} code
 * @returns {string}
 */
export const candidateLabel = (code) => `Candidate No. ${formatCvCode(code)}`;

/**
 * Filename for a downloaded CV: never leaks the name when it is obfuscated.
 * @param {{ fullName?: string, code?: string }} cv
 * @param {boolean} nameObfuscated
 * @returns {string}
 */
export const cvDownloadFilename = (cv, nameObfuscated) => {
  if (nameObfuscated && cv?.code) return `Candidate-${cv.code}.docx`;
  return `${cv?.fullName || 'CV'}.docx`;
};
